import React, { Component } from "react"
import { Input, InputNumber, Select } from "../core";
import { connect } from 'react-redux'
import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import {
    setKeyValueAction,
    clearModalAction
} from '../../redux/actions/ModalEmployeeAction'


class PanelMrDetail extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            view_ref_no:false
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleMrRefChange = this.handleMrRefChange.bind(this)
    }

    handleChange(event) {
        this.props.handleChange(event);
    }

    handleMrRefChange(event) {
        this.props.handleMrRefChange(event);
    }

    toBoolean(value) {
        if (value === 1)
            return true
        else if (value === true)
            return true
        else
            return false
    }

    searchEmployeeModal(empCode, empName) {
        console.log("openSearch");

        this.props.clearSearchDirectoryInfo();
        this.props.clearModal();

        this.props.setKeyValue('T_MR_DETAIL', empCode, empName)



        window.$('#searchEmployeeModal').modal('show');

    }

    formatDisplayEmployee(empCode, empName) {
        if (empCode !== null && empCode !== '')
            return `${empName} (${empCode})`
        else
            return ''
        }

    render() {
        const panelStyle = {
            paddingTop: '25px',
            borderRadius: '15px',
            border: '1px solid',
            borderColor: '#a4a4a6',
            paddingBottom: "15px"
        };

        let {
            t_MR_DETAIL,
            viewMode,
            po_no,
            status,
            mrviewMode,
            mrRefs,
            t_PO_COMMITTEE
        } = this.props;
        console.log( "viewMode ==> ",viewMode);
        let isContract = po_no && po_no.startsWith('41') ? true : false;
        let countMrRefs = this.props ? this.props.mrRefs.length : 0; // ใช้สำหรั้บเช็คว่าเป็น PO ใบแรกหรือไม่ ถ้า MrRefs ม่ีมากกว่า 1 แสดงว่าไม่ใช่ใบแรก
        return (
            <div>
                <div className="sp-page-wrapper" style={{ marginLeft: 15, marginRight: 15 }}>
                    <div className="sp-table-container" style={{ paddingBottom: 25 }}>
                        <h3 className="rrs-sub-header">คณะกรรมการตรวจรับ</h3>
                        <div className="row no-gutters sp-table-content">
                            <table className="sp-table table rrs-table rrs-table-purple">
                                <thead>
                                    <tr className="sp-table-header">
                                        {/* <th className="th-no"><div className="th-text">ลำดับ</div></th> */}
                                        <th className="th-docnum">
                                            <div className="th-text">ชื่อ - นามสกุล</div>
                                        </th>
                                        <th className="th-projectname">
                                            <div className="th-text">หน่วยงาน</div>
                                        </th>
                                        <th className="th-budget">
                                            <div className="th-text">โทรศัพท์</div>
                                        </th>
                                        <th className="th-method">
                                            <div className="th-text">Email</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {t_PO_COMMITTEE &&
                                        t_PO_COMMITTEE.map((item, index) => (
                                            <tr key={index + 1}>
                                                {/* <td className="td-num">{item.sequence}</td> */}
                                                <td className="nowrap-whitespace">{item.fullname}</td>
                                                <td className="nowrap-whitespace">{item.department}</td>
                                                <td className="nowrap-whitespace">{item.telephone}</td>
                                                <td>
                                                    <a href={"mailto:" + item.email + ";"}>
                                                        {item.email}
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="row mt-0 mb-0" style={panelStyle} >
                    <div className="col-lg-12 pr-md-12">

                        {isContract === false && countMrRefs > 1 && false && (
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="rrs-form">
                                        <label htmlFor="ref_no" className="rrs-label">รวมรายการ 'ตรวจรับการจัดหา' ภายใต้ PO เดียวกัน  (Merge MR)</label>
                                        <div className="rrs-detail-data">

                                            <Select
                                                viewMode={this.props.viewModeForRefNo || this.state.view_ref_no}
                                                key={`ref_no${t_MR_DETAIL.transaction_no}`}
                                                name="ref_no"
                                                value={t_MR_DETAIL.ref_no}
                                                onChange={(event) => this.handleMrRefChange(event)}
                                            >
                                                {this.props.mrRefs && this.props.mrRefs.map((data, index) => (
                                                    <option
                                                        key={index}
                                                        value={data.value}>
                                                        {data.display}
                                                    </option>
                                                )
                                                )}

                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 text-right">
                                    <div className="rrs-form">
                                        &nbsp;
                                                    {/* render MR No */}
                                        {/* { 
                                                        t_MR_DETAIL && t_MR_DETAIL.running != 0 
                                                        && (<label htmlFor="ref_no" className="rrs-label">MR No : MR{t_MR_DETAIL.running} </label>)
                                                    } */}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="approver_name" id="#lbl-mr.approver" className="rrs-label">
                                        <span className="required">*</span> ผู้อนุมัติ 
                                            </label>
                                    <div className="rrs-detail-data">
                                        <Input
                                            key={`approver_name${t_MR_DETAIL.transaction_no}`}
                                            value={this.formatDisplayEmployee(t_MR_DETAIL.approver_code, t_MR_DETAIL.approver_name)}
                                            className="form-control form-control-search-2"
                                            id="approver_name"
                                            name="approver_name"
                                            onClick={() => this.searchEmployeeModal("approver_code", "approver_name")}
                                            readOnly={true }
                                            doctype="*"
                                            tagid="mr.approver"
                                            viewMode={true}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="receiver_name" id="#lbl-mr.receiver" className="rrs-label">
                                        <span className="required">*</span> ชื่อผู้รับงาน
                                            </label>
                                    <div className="rrs-detail-data">
                                        <Input
                                            key={`approver_name${t_MR_DETAIL.transaction_no}`}
                                            value={this.formatDisplayEmployee(t_MR_DETAIL.receiver_code, t_MR_DETAIL.receiver_name)}
                                            className="form-control form-control-search-2"
                                            id="receiver_name"
                                            name="receiver_name"
                                            onClick={() => this.searchEmployeeModal("receiver_code", "receiver_name")}
                                            readOnly={true }
                                            doctype="*"
                                            tagid="mr.receiver"
                                            disabled={true}
                                            viewMode={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4" disable={viewMode ? "disabled" : null} >
                                <div className="rrs-form">
                                    <label htmlFor="installment_no_mr" id="#lbl-mr.installment" className="rrs-label">
                                        งวดที่
                                            </label>
                                    <div className="d-md-flex align-items-center">
                                        <div className="col-3 rrs-detail-data pl-0">
                                            <InputNumber
                                                key={`installment_no_mr${t_MR_DETAIL.transaction_no}`}
                                                type="text"
                                                id="installment_no_mr"
                                                name="installment_no_mr"
                                                value={t_MR_DETAIL.installment_no_mr}
                                                className="form-control"
                                                onChange={this.handleChange}
                                                doctype="*"
                                                // tagid="mr.installment"
                                                disabled={true} //{viewMode}
                                                maxlength="50"
                                                viewMode={true}
                                            />
                                        </div>
                                        <div className="col-auto px-0">
                                            <label className={`checkboxcontainer rrs-fine-label mb-0 ${viewMode ? '' : 'clickable'}`}>งวดสุดท้าย
                                                        <input
                                                    className={viewMode ? "form-control.form-control-gray1" : ""}
                                                    type="checkbox"
                                                    key={`final_installment_flag${t_MR_DETAIL.transaction_no}`}
                                                    name="final_installment_flag"
                                                    onChange={this.handleChange}
                                                    id="final_installment_flag"
                                                    checked={this.toBoolean(t_MR_DETAIL.final_installment_flag)}
                                                    disabled={true}
                                                    viewMode={true}
                                                />
                                                <span className="checkboxmark" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 pr-md-12">
                        <div className="rrs-form">
                            <label htmlFor="cc" className="rrs-label">หมายเหตุ</label>
                            <div className="rrs-detail-data">
                                <textarea
                                    cols={30}
                                    rows={50}
                                    key={`remark${t_MR_DETAIL.transaction_no}`}
                                    name="remark"
                                    onChange={this.handleChange}
                                    id="remark"
                                    value={t_MR_DETAIL.remark != null ? t_MR_DETAIL.remark : ''}
                                    className="form-control rrs-textarea"
                                    disabled={viewMode}
                                    maxlength="500"

                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



const mapStateToProps = state => {
    const { MasterRedux, MainRedux } = state

    return {
        po_no: MainRedux.po_no,
        mrRefs: MasterRedux.mrRefs,
        t_PO_COMMITTEE: MainRedux.t_PO_COMMITTEE
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
         setKeyValue: (table, empCode, empName) => dispatch(setKeyValueAction(table, empCode, empName)),
        clearModal: () => dispatch(clearModalAction()),

    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PanelMrDetail)